import { OwnProps } from '~/types/ownProps';

function meetsDataDependencies(props: OwnProps) {
  const { currentProperty } = props;

  return !!currentProperty?.propertyDetailsDefault;
}

const step = {
  route: '/homeowners-insurance/quotes/construction',
  isAccessible: ({ application: { isAutoOnly } }: OwnProps) => !isAutoOnly,
  breadcrumbStep: 'property',
  meetsDataDependencies,
};

export default step;
